import React from "react";
import Tabs, { Tablist } from "../../components/ui/Tabs/Tabs";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Filter from "./Components/Filter";
import StatisticsTable from "./Components/StatisticsTable";

const tabs = [
  {
    title: "디폴트",
    id: 1,
  },
  {
    title: "전체 펼침 (재고 현황, 상품 판매현황)",
    id: 2,
  },
  {
    title: "상품 판매현황 펼침",
    id: 3,
  },
];

const data = [{ name: "카테고리 선택" }];

function ProductStatistics() {
  const [currentTab, setCurrentTab] = React.useState(1);
  const onChangeTab = (id) => {
    setCurrentTab(id);
  };

  return (
    <div>
      <div>
        <TitlePage title={"상품 통계"} />
      </div>
      <Tabs
        isFirstLong
        onChangeTab={onChangeTab}
        currentTab={currentTab}
        tabs={tabs}
      >
        <Tablist currentTab={currentTab} index={1}>
          <Filter categoriesData={data} isQrButton={false} />
          <StatisticsTable />
        </Tablist>
        <Tablist currentTab={currentTab} index={2}>
          <Filter categoriesData={data} isOverall={true} isQrButton={false} />
          <StatisticsTable isSecondTab={true} />
        </Tablist>
        <Tablist currentTab={currentTab} index={3}>
          <Filter
            categoriesData={data}
            isOverall={false}
            isProductSpread
            isQrButton={false}
          />
          <StatisticsTable isThirdTab={true} isSecondTab={true} />
        </Tablist>
      </Tabs>
    </div>
  );
}

export default ProductStatistics;
